module.exports = __webpack_public_path__ + "static/rscore-0b3415ba5b5e11c0934d035efc5f7b8f.png";